import { Component, OnInit, Renderer2 } from '@angular/core';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import {
  PushNotifications,
  PushNotificationSchema,
  Token,
} from '@capacitor/push-notifications';
import { ModalController, Platform } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import {
  AppTrackingStatusResponse,
  AppTrackingTransparency,
} from 'capacitor-plugin-app-tracking-transparency';
import { CookieConsentModalComponent } from './pages/shared/cookie-consent-modal/cookie-consent-modal.component';
import { CookieConsentService } from './services/cookie-consent.service';
import { RoutingEventsService } from './services/routing-events.service';
import { StorageService } from './services/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private screenOrientation: ScreenOrientation,
    private translationService: TranslocoService,
    private storageService: StorageService,
    private routingEventsService: RoutingEventsService,
    private renderer: Renderer2,
    private modalController: ModalController,
    private cookieConsentService: CookieConsentService,
    private platform: Platform,
  ) {}

  async ngOnInit() {
    const language = this.storageService.getPersistent('lang');
    if (language != null) {
      this.translationService.setActiveLang(language);
    }

    this.routingEventsService.setupRouterEvents();

    if (Capacitor.isNativePlatform()) {
      this.renderer.addClass(document.body, 'is-native-platform');

      await this.screenOrientation.lock(
        this.screenOrientation.ORIENTATIONS.PORTRAIT,
      );

      this.handlePushNotifications();
    } else {
      this.renderer.addClass(document.body, 'is-web-platform');
    }
  }

  async ngAfterViewInit() {
    if (!Capacitor.isNativePlatform()) {
      if (this.cookieConsentService.areCookiesAllowed) {
        this.cookieConsentService.runCookieDependentServices();
      } else if (!this.cookieConsentService.hasCookieConsentBeenDenied) {
        const cookieConsentModal = await this.modalController.create({
          component: CookieConsentModalComponent,
          cssClass: 'cookieConsentModal',
          backdropDismiss: false,
        });
        await cookieConsentModal.present();
      }
    } else if (this.platform.is('ios')) {
      const trackingConsent: AppTrackingStatusResponse =
        await AppTrackingTransparency.requestPermission();
      if (trackingConsent.status === 'authorized') {
        this.cookieConsentService.runCookieDependentServices();
      }
    } else {
      this.cookieConsentService.runCookieDependentServices();
    }
  }

  private handlePushNotifications() {
    PushNotifications.requestPermissions()
      .then((result) => {
        if (result.receive === 'granted') {
          PushNotifications.register();
        }
      })
      .catch((err) => console.log(err));

    PushNotifications.addListener('registration', (token: Token) => {
      this.storageService.set('pushNotificationToken', token.value);
    }).catch((err) => console.log(err));

    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        await LocalNotifications.schedule({
          notifications: [
            {
              title: notification.title,
              body: notification.body,
              id: 1,
            },
          ],
        });
      },
    );
  }
}
